// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"_2lQ2R_"};